import { useState } from "react";
import NewsCard from "../../Molecules/NewsCard/NewsCard";
import { Button } from "../../Atoms/Button/Button";
import usePosts from "../../../hooks/usePosts";
import Loader from "../../Atoms/Loader/Loader";

const OtherNews = ({ succesCase, toGet, postulacionesCase, slug }) => {
	const [showButton, setShowButton] = useState(true);
	const { loading, posts, changePaginationNumb, paginationNumb } =
		usePosts(toGet, 3, setShowButton, slug);

	let route = "noticias";

	if (toGet === "casos-exitos") {
		route = "casos-de-exito";
	} else if (toGet === "carreras") {
		route = "carreras";
	}

	return (
		<div className=" max-width">
			{!succesCase && !postulacionesCase && (
				<h5 className="c-yellow t5 yellow-line right-side">Otras Noticias</h5>
			)}
			{postulacionesCase && (
				<h5 className="c-yellow t5 yellow-line right-side">
					Otras Oportunidades
				</h5>
			)}
			<div
				className={`flex space-around wrap ${
					!showButton && "bottom-space-section"
				}`}
			>
				{loading && paginationNumb === 0 ? (
					<Loader />
				) : (
					posts.map((post, index) => (
						<NewsCard
							key={index}
							date={new Date(post.createdAt).toLocaleDateString()}
							post={post}
							linkRoute={`/${route}/${
								post.slug
							}`}
							linkText="LEER NOTICIA"
						/>
					))
				)}
			</div>
			{loading && paginationNumb > 0 && (
				<div className="top-space-section">
					<Loader />
				</div>
			)}
			{showButton && (
				<div className="flex center-content-items mt-40 mb-40">
					<Button
						type="button light-blue outline"
						content={
							!succesCase ? "Cargas más noticias" : "Cargas más casos de éxito"
						}
						clickHandler={changePaginationNumb}
					/>
				</div>
			)}
		</div>
	);
};

export default OtherNews;
